import React from 'react';

const SvgCommunication31 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M6.5 9H9v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V9h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H11V4.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V7H6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm9.5 5H6a5 5 0 0 0-3.54 1.46l-.46.42V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm4-10a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v15.5a.5.5 0 0 0 .5.5.49.49 0 0 0 .35-.15l3-3A3 3 0 0 1 6 16h10a4 4 0 0 0 4-4z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgCommunication31 svgRef={ref} {...props} />);
export default ForwardRef;
